import { PortalContext, usePortalSettingSet } from "../../../context/portal-context";
import usePageTitle from "../../../hooks/use-page-title";
import ProfileBox from "../../../components/portal/ProfileBox";
import AppUserContext from "../../../context/app-user-context";
import { useContext, useEffect, useRef, useState } from "react";
import Utils from "../../../utils/utils";
import Config from "../../../config/config";
import { Link } from "react-router-dom";
import Debouncer from "../../../modules/debouncer/debouncer";
import Notifier from "../../../modules/notifier/notifier";
import FGInput from "../../../components/dumb/FGInput";
import ROLE from "../../../modules/role";
import UserImage from "../../../components/portal/UserImage";
import { HiPencil } from "react-icons/hi";
import ModuleValidation from "../../../modules/validation";
import ApiUser from "../../../modules/api/user";
import AppUser from "../../../modules/app-user/app-user";

const showLabel = (txt) => Utils.ifEmptyOrUndefinedThen(txt, Config.CHAR_EMPTY);

export default function PageProfileEdit() {
  const title = "Edit Profile";
  usePageTitle(title);
  usePortalSettingSet("label_header", title);
  const { setCustomText } = useContext(PortalContext);
  useEffect(() => {
    setCustomText(title);
  }, []);
  const user = useContext(AppUserContext);
  const refInputFilePicture = useRef<HTMLInputElement>();
  const [formChanged, setFormChanged] = useState(false);
  const [reset, setReset] = useState(false);
  const [sending, setSending] = useState(false);
  const [formData, setFormData] = useState({
    name: user.name,
    studentId: user.studentId,
    email: user.email,
    alias: user.alias,
    avatar: user.avatar
  });

  const resetForm = () => {
    setFormChanged(false);
    setFormData({
      avatar: user.avatar,
      name: user.name,
      studentId: user.studentId,
      email: user.email,
      alias: user.alias,
    });
    setReset(i => !i);
  };

  const onChange = (e: any) => {
    setFormData((_) => ({ ..._, [e.target.name]: e.target.value }));
    setFormChanged(true);
  };

  const validateBeforeSubmit = () => {
    let errors = [];
    if (formData.alias && formData.alias.length > 50) {
      errors.push(
        "Your alias name is too long. Please enter a maximum of 50 characters."
      );
    }
    if (formData.alias && !/[a-zA-Z]/.test(formData.alias)) {
      errors.push("Your alias name should contain at least one letter.");
    }
    return errors;
  };

  const handleOnSubmit = (e: any) => {
    e.preventDefault();
    let errors = validateBeforeSubmit();
    if (errors.length) {
      Notifier.error(errors[0]);
      return;
    }
    setSending(true);
    Debouncer.execute("CHANGE_AVATAR", async () => {
      const res = await ApiUser.updateAvatar({
        alias: formData.alias.trim(),
        avatar: formData.avatar,
        modifiedUserId: user.id,
        id: user.referenceUserId
      });

      if (res.status) {
        await AppUser.refreshUser();
        Notifier.success("Profile updated");
      } else {
        Notifier.error(res.message);
      }

      setSending(false);
    });
  };

  const handleSelectPicture = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const validationResult = await ModuleValidation.isImageValid(file);

    if (!validationResult.valid) {
      return Notifier.error(validationResult.message);
    }

    Utils.getBase64FromFile(file).then(img => {
      setFormChanged(true);
      setFormData(r => ({ ...r, avatar: img }));
    });
  };

  return <main className="content-generic content-generic--fluid" data-comp="PageProfile">

    <ProfileBox showEditIcon={false} showEditProfile={false} />

    <div className="row">
      <div className="col-md-12 col-lg-9">
        <h1 className="fs-title d-none">Edit Profile</h1>

        <div className="edit-profile mb-3">
        <form onSubmit={handleOnSubmit} className="box-default bg-white">
            <div className="ep__row">
              <div className="ep__col">
                {false && <FGInput label="Name" type="text"
                  name="name"
                  value={formData.name}
                  disabled
                />}

                {false && user.role === ROLE.STUDENT && <FGInput label="Student ID" type="text"
                  name="name"
                  value={formData.studentId}
                  disabled
                />}

                {false && <FGInput label="Email" type="text"
                  name="email"
                  value={formData.email}
                  disabled
                />}

                {user.role === ROLE.STUDENT && <FGInput label={<>Alias <em>(your alternate name)</em></>} type="text"
                  autoFocus={true}
                  name="alias"
                  value={formData.alias}
                  disabled={user.role !== ROLE.STUDENT}
                  onChange={onChange}
                />}
              </div>
            </div>
            <button type="submit" className="btn btn-primary"
              disabled={!formChanged}
            >Save Changes</button>
          </form>
        </div>
      </div>
    </div>

  </main>
}
